import { ERROR } from "constant/message";
import {
  MODULE_REPRODUCTION,
  MODULE_LOT_PUCE,
  MODULE_PUCE,
  MODULE_ROBE,
  MODULE_TAG,
  MODULE_RACE,
  PATH_USER_N3,
  PATH_USER_N4I,
  PATH_USER_N4R,
  MODULE_ENTITE,
  PATH_USER_N5E,
  PATH_USER_N5P,
  MODULE_DEMANDE_IDENTIFICATION,
  MODULE_ANIMAL,
  MODULE_ROLE,
  MODULE_USER,
  MODULE_LOT,
  MODULE_CAMPAGNE,
  MODULE_FERME,
  MODULE_ESPECE,
  MODULE_EXPLOITATION,
} from "constant/moduleInfo";
import { ADMIN_REGION_ROLE, ADMIN_PAYS_ROLE, SUPER_ADMIN_ROLE } from "constant/role";

import CurrentUserRole from "utils/currentUserRole";

import { checkRoleExist, isAdminDepartemental } from "utils/userInfos";

export default function useArrayOperation() {
  const sortArray = (array, labelName) => {
    try {
      const result = array
        ?.map((i) => {
          const item = {
            ...i,
            ...{ label: i[labelName] },
          };
          return item;
        })
        ?.sort((a, b) => {
          const nameA = a.label?.toUpperCase();
          const nameB = b.label?.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          return 0;
        });
      return result;
    } catch (error) {
      // eslint-disable-next-line no-alert
      alert(error);
      return ERROR;
    }
  };
  // Remove duplicated regions/ departement in array of lieu
  const removeDuplicateItem = (array, labelName) => {
    try {
      const dataArr = array?.map((i) => {
        const item = {
          ...i,
          ...{ label: i[labelName] },
        };
        return item;
      });
      const uniqueMap = new Map();

      const newArray = dataArr?.reduce((accumulator, current) => {
        let identifier = "";
        identifier = current.label;

        if (!uniqueMap.has(identifier)) {
          uniqueMap.set(identifier, true);

          accumulator.push(current);
        }

        return accumulator;
      }, []);
      const result = sortArray(newArray, "label");

      return result;
    } catch (error) {
      // eslint-disable-next-line no-alert
      alert(error);
      return error;
    }
  };
  const customArrItem = (array, moduleName, pathName) => {
    try {
      const allowedRoles = [SUPER_ADMIN_ROLE, ADMIN_PAYS_ROLE];

      const isAdminGeneral = checkRoleExist(ADMIN_PAYS_ROLE);
      const isSuperAdmin = checkRoleExist(SUPER_ADMIN_ROLE);
      // const isResponsableFerme = checkRoleExist(RESPONSABLE_FERME);
      const result = array?.map((i) => {
        let newKeys = {};
        if (moduleName === MODULE_FERME) {
          const typeFerme = i?.fermeType;
          console.log("sss", typeFerme);
          if (typeFerme === "DEFAULT") {
            newKeys = { isAnimal: true };
          } else {
            newKeys = { isAnimal: true, isEdit: true };
          }
        } else if (moduleName === MODULE_LOT) {
          newKeys = { isAnimal: true };
        } else if (moduleName === MODULE_EXPLOITATION) {
          newKeys = { isDetail: true, isEdit: true };
        } else if (moduleName === MODULE_CAMPAGNE) {
          newKeys = { isEdit: true, nom: i.nomCampagn };
        } else if (moduleName === MODULE_USER) {
          if (!i.roles?.some((x) => x.roleName === SUPER_ADMIN_ROLE)) {
            let showActions = allowedRoles.some((role) => CurrentUserRole()?.includes(role));
            const canAddbyAdminRegion = checkRoleExist(ADMIN_REGION_ROLE);
            if (
              isAdminDepartemental() &&
              (pathName === PATH_USER_N5E ||
                pathName === PATH_USER_N5P ||
                pathName === PATH_USER_N4R ||
                pathName === PATH_USER_N4I)
            ) {
              showActions = true;
            }
            if (
              canAddbyAdminRegion &&
              (pathName === PATH_USER_N3 ||
                pathName === PATH_USER_N5E ||
                pathName === PATH_USER_N5P ||
                pathName === PATH_USER_N4R ||
                pathName === PATH_USER_N4I)
            ) {
              showActions = true;
            }

            if (showActions) {
              newKeys = {
                isReset: true,
                isUser: true,
                userName: `${i.prenom} ${i.nom}`,

                isEdit: true,
              };
            } else {
              newKeys = {
                userName: `${i.prenom} ${i.nom}`,
                isDetail: true,
              };
            }
          }
        } else if (moduleName === MODULE_ROLE) {
          newKeys = {
            isRole: true,
          };
        } else if (moduleName === MODULE_ANIMAL) {
          // const isEdit

          newKeys = { isDetail: true, isEdit: true };
        } else if (moduleName === MODULE_ESPECE) {
          newKeys = { isDetail: true };
          if (isSuperAdmin) {
            newKeys.isEdit = true;
          }
        } else if (moduleName === MODULE_RACE) {
          // newKeys = { isDetail: true };
          if (isSuperAdmin) {
            newKeys = { isEdit: true };
          }
        } else if (moduleName === MODULE_DEMANDE_IDENTIFICATION) {
          newKeys = { isDetail: true };
        } else if (moduleName === MODULE_ENTITE) {
          newKeys = { isDetail: true };
          if (isSuperAdmin || isAdminGeneral) {
            newKeys.isEdit = true;
          }
        } else if (moduleName === MODULE_TAG) {
          if (isSuperAdmin || isAdminGeneral) {
            newKeys.isEdit = true;
          }
        } else if (moduleName === MODULE_ROBE) {
          if (isSuperAdmin) {
            newKeys.isEdit = true;
          }
        } else if (moduleName === MODULE_PUCE) {
          if ((isSuperAdmin || isAdminGeneral) && i?.status !== "ASSIGNEE") {
            newKeys.isEdit = true;
          }
          newKeys.isDetail = true;
        } else if (moduleName === MODULE_LOT_PUCE) {
          if ((isSuperAdmin || isAdminGeneral) && i?.isEditable === true) {
            newKeys.isEdit = true;
          }
          newKeys.isDetail = true;
        } else if (moduleName === MODULE_REPRODUCTION) {
          /* if ((isSuperAdmin || isAdminGeneral) && i?.isEditable === true) {
            newKeys.isEdit = true;
          } */
          newKeys.isDetail = true;
        }

        const item = {
          ...i,
          ...newKeys,
        };
        return item;
      });
      return result;
    } catch (error) {
      // eslint-disable-next-line no-alert
      alert(error);
      return ERROR;
    }
  };
  function removeItemFromArray(array, itemToRemove) {
    return array?.filter((item) => item !== itemToRemove);
  }

  const findDuplicatesInArray = (array, key) => {
    const valueCount = {};
    const duplicates = [];

    array?.forEach((item) => {
      const value = item[key];
      if (valueCount[value]) {
        valueCount[value] += 1;
      } else {
        valueCount[value] = 1;
      }
    });

    Object.keys(valueCount).forEach((value) => {
      if (valueCount[value] > 1) {
        duplicates.push(value);
      }
    });

    return duplicates;
  };
  return {
    removeDuplicateItem,
    customArrItem,
    sortArray,
    removeItemFromArray,
    findDuplicatesInArray,
  };
}
